import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { FaShieldAlt } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import './CookieConsent.scss'

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(() => !localStorage.getItem('cookie_consent'))

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'true')
    setVisible(false)
  }

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="cookie-consent"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
        >
          <div className="cookie-consent-card">
            <div className="cookie-consent-icon">
              <FaShieldAlt />
            </div>
            <div className="cookie-consent-body">
              <p className="cookie-consent-text">
                We use cookies to keep you signed in and improve your experience.
                By continuing, you agree to our{' '}
                <Link to="/privacy-policy" className="cookie-consent-link">
                  Privacy Policy
                </Link>.
              </p>
            </div>
            <button className="btn btn-primary cookie-consent-accept" onClick={handleAccept}>
              Accept
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default CookieConsent
